<template>
  <div class="dw-footer-main">Powered by 浙江财闻传媒科技有限公司</div>
</template>
<script>
import API from "@/api/index.js";

export default {
  name: "DwFooter",
  data() {
    return {
      footerInfo: {}
    };
  },
  mounted() {
    // this.queryDWSurveyFooter();
  },
  methods: {
    queryDWSurveyFooter() {
      this.axios.get(API.surveyFooterInfo, {}).then(response => {
        const resultData = response.data.data;
        console.debug(resultData);
        this.footerInfo = resultData;
      });
    }
  }
};
</script>

<style scoped>
.dw-footer-main {
  text-align: center;
  font-size: 14px;
  color: grey;
  line-height: 40px;
}
.dw-footer-main a {
  text-decoration: none;
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwFooter.vue